module.exports = __webpack_public_path__ + "static/img/parallel-gateway.cf160d7c.svg";